<template>
  <div>
    <table-card
      ref="datatable"
      module="VehicleIcon"
      :headers="headers"
      :actions="actions"
    >
      <template v-slot:action>
        <vs-button
          color="primary"
          type="gradient"
          class="mb-4 md:mb-0"
          @click="add"
          >Add New Data</vs-button
        >
      </template>
    </table-card>

    <vs-popup
      classContent="popup-example"
      :title="popupTitle"
      :active.sync="showPopup"
    >
      <template>
        <div class="vx-row mb-3">
          <div class="vx-col sm:w-1/2 w-full">
            <label class="vs-input--label">Vehicle Type</label>
            <v-select
              :options="vehTypeList"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              class="w-full"
              v-model="input.veh_type"
            />
          </div>
          <div class="vx-col sm:w-1/2 w-full">
            <vs-input label="Name" class="w-full" v-model="input.name" />
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col sm:w-1/2 w-full">
            <label class="vs-input--label">Parking Icon</label>
            <input
              type="file"
              label="Parking Icon"
              @change="handleFile('parking')"
              ref="parking"
              class="w-full file-input"
            />
          </div>
          <div class="vx-col sm:w-1/2 w-full">
            <label class="vs-input--label">Acc On Icon</label>
            <input
              type="file"
              label="ACC On Icon"
              @change="handleFile('acc_on')"
              ref="acc_on"
              class="w-full file-input"
            />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/2 w-full">
            <label class="vs-input--label">Lost Icon</label>
            <input
              type="file"
              label="lost Icon"
              @change="handleFile('lost')"
              ref="lost"
              class="w-full file-input"
            />
          </div>
          <div class="vx-col sm:w-1/2 w-full">
            <label class="vs-input--label">Alarm Icon</label>
            <input
              type="file"
              label="Alarm Icon"
              @change="handleFile('alarm')"
              ref="alarm"
              class="w-full file-input"
            />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full ml-auto">
            <vs-button
              :disabled="isSubmit"
              id="submitBtn"
              class="mr-3 mb-2 vs-con-loading__container"
              @click="submit"
              >Submit</vs-button
            >
            <vs-button
              :disabled="isSubmit"
              v-show="action === 'add'"
              color="warning"
              type="border"
              @click="reset"
              class="mb-2"
              >Reset</vs-button
            >
          </div>
        </div>
      </template>
    </vs-popup>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import TableCard from '@/components/TableCard'

export default {
  components: {
    vSelect,
    TableCard
  },

  data() {
    return {
      isSubmit: false,
      showPopup: false,
      popupTitle: '',
      action: '',
      input: {
        veh_type: '',
        name: '',
        parking: '',
        acc_on: '',
        lost: '',
        alarm: ''
      },
      file: {}
    }
  },

  computed: {
    headers() {
      return [
        [
          { label: 'Vehicle Type', value: 'veh_type.name' },
          { label: 'Name', value: 'name' },
          { label: 'Parking Icon', value: 'parking', formatter: this.showIcon },
          { label: 'Acc On Icon', value: 'acc_on', formatter: this.showIcon },
          { label: 'Lost Icon', value: 'lost', formatter: this.showIcon },
          { label: 'Alarm Icon', value: 'alarm', formatter: this.showIcon }
        ]
      ]
    },
    actions() {
      return [
        {
          name: 'Edit',
          action: this.edit,
          icon: 'icon-edit',
          color: 'success'
        },
        {
          name: 'Delete',
          action: this.del,
          icon: 'icon-trash',
          color: 'danger'
        }
      ]
    },
    imgSource() {
      return `${this.$api.base_url}/uploads/icon`
    },
    vehTypeList() {
      return this.$store.state.VehicleType.select
    }
  },
  watch: {},
  created() {
    this.$store.dispatch('VehicleType/select')
  },
  mounted() {},

  methods: {
    initTable() {
      this.$refs.datatable.initTable()
    },

    reset() {
      Object.keys(this.input).map((item) => {
        this.input[item] = null
      })
      this.file = {}

      let icon_type_list = ['parking', 'acc_on', 'lost', 'alarm']
      icon_type_list.map((l) => {
        this.$refs[l].value = ''
      })
    },

    handleFile(key) {
      this.file[key] = this.$refs[key].files[0]
    },

    add() {
      this.reset()
      this.action = 'store'
      this.popupTitle = 'Add Vehicle Icon'
      this.showPopup = true
    },

    async edit(id) {
      let icon_type_list = ['parking', 'acc_on', 'lost', 'alarm']
      icon_type_list.map((l) => {
        this.$refs[l].value = ''
      })

      this.input.id = id
      this.action = 'update'
      this.popupTitle = 'Edit Vehicle Icon'

      await this.$store.dispatch('VehicleIcon/detail', id).then((data) => {
        this.input.name = data.name
        this.input.veh_type = this.vehTypeList.find((item) => {
          return item.value === data.veh_type_id
        })
      })
      this.showPopup = true
    },

    async submit() {
      this.isSubmit = true
      this.loadingStart('#submitBtn', 'primary')

      const data = {
        ...this.input,
        veh_type_id: this.input.veh_type ? this.input.veh_type.value : null,
        parking:
          typeof this.file.parking !== 'undefined' ? this.file.parking : null,
        acc_on:
          typeof this.file.acc_on !== 'undefined' ? this.file.acc_on : null,
        lost: typeof this.file.lost !== 'undefined' ? this.file.lost : null,
        alarm: typeof this.file.alarm !== 'undefined' ? this.file.alarm : null
      }

      const { status, message } = await this.$store.dispatch(
        `VehicleIcon/${this.action}`,
        data
      )
      this.isSubmit = false
      this.loadingStop('#submitBtn')
      if (status) {
        this.showNotify(message)
        this.initTable()
        this.reset()
        this.showPopup = false
      }
    },

    del(id) {
      this.input.id = id
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Delete Vehicle Icon`,
        text: 'Are you sure want to Delete this Vehicle Icon ?',
        accept: this.confirmDelete
      })
    },

    async confirmDelete() {
      const { status, message } = await this.$store.dispatch(
        'VehicleIcon/delete',
        this.input.id
      )
      if (status) {
        this.showNotify(message)
        this.initTable()
      }
    },

    loadingStart(el, color = 'success') {
      this.$vs.loading({
        background: color,
        color: '#fff',
        container: el,
        scale: 0.45
      })
    },

    loadingStop(el) {
      this.$vs.loading.close(`${el} > .con-vs-loading`)
    },

    showNotify(msg, type = 'success') {
      this.$vs.notify({
        title: 'Thank You',
        text: msg,
        color: type,
        position: 'top-right'
      })
    },

    showIcon(data) {
      return `<img style="width: 50px; height: 50px;" src="${data}" alt="">`
    }
  }
}
</script>
